// Mutations
export const SET_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.professionals.data = payload
    state.professionals.lastUpdate = new Date()
  }
}
export const ADD_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      // Match por id_profissional (chave estável); id (partners) pode ser
      // ausente quando o profissional foi criado sem dados de partners.
      const matchKey = data.id_profissional
        ? (item) => item.id_profissional === data.id_profissional
        : (item) => item.id === data.id && data.id !== undefined
      const old = state.professionals.data.find(matchKey)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.professionals.data.push(data)
      }
    })
  }
}
export const SET_PROFESSIONALS_LOADING = (state, payload) => {
  state.professionals.loading = payload
}

export const SET_PROFESSIONALS_IS_ACTIVE = (state, payload) => {
  state.professionals.isActive = payload
}

// Mutations
export const SET_ALL_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.allProfessionals.data = payload
    state.allProfessionals.lastUpdate = new Date()
  }
}
export const ADD_ALL_PROFESSIONALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.allProfessionals.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.allProfessionals.data.push(data)
      }
    })
  }
}
export const SET_ALL_PROFESSIONALS_LOADING = (state, payload) => {
  state.allProfessionals.loading = payload
}

export const SET_ALL_PROFESSIONALS_IS_ACTIVE = (state, payload) => {
  state.allProfessionals.isActive = payload
}

export const SET_CHURN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.churn.data = payload
    state.churn.lastUpdate = new Date()
  }
}
export const ADD_CHURN = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.churn.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.churn.data.push(data)
      }
    })
  }
}
export const SET_CHURN_LOADING = (state, payload) => {
  state.churn.loading = payload
}

export const SET_GOALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.goals.data = [payload]
    state.goals.lastUpdate = new Date()
  }
}
export const ADD_GOALS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.goals.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.goals.data.push(data)
      }
    })
  }
}
export const SET_GOALS_LOADING = (state, payload) => {
  state.goals.loading = payload
}

export const SET_GOALS_MANAGER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.goalsManager.data = payload
    state.goalsManager.lastUpdate = new Date()
  }
}
export const ADD_GOALS_MANAGER = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.goalsManager.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.goalsManager.data.push(data)
      }
    })
  }
}
export const SET_GOALS_MANAGER_LOADING = (state, payload) => {
  state.goalsManager.loading = payload
}

export const SET_STATISTICS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.statistics.data = payload
    state.statistics.lastUpdate = new Date()
  }
}
export const ADD_STATISTICS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.statistics.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.statistics.data.push(data)
      }
    })
  }
}
export const SET_STATISTICS_LOADING = (state, payload) => {
  state.statistics.loading = payload
}

export const SET_CORPORATE_POLL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.corporatePoll.data = payload
    state.corporatePoll.lastUpdate = new Date()
  }
}
export const ADD_CORPORATE_POLL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.corporatePoll.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.corporatePoll.data.push(data)
      }
    })
  }
}
export const SET_CORPORATE_POLL_LOADING = (state, payload) => {
  state.corporatePoll.loading = payload
}
export const SET_USER_RETURN_DESTINATION = (state, payload) => {
  state.userReturnDestination.url = payload
}
export const SET_BANK_DETAILS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.bankDetails.data = payload
    state.bankDetails.lastUpdate = new Date()
  }
}
export const ADD_BANK_DETAILS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.bankDetails.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.bankDetails.data.push(data)
      }
    })
  }
}
export const SET_BANK_DETAILS_LOADING = (state, payload) => {
  state.bankDetails.loading = payload
}

